import React, { useEffect, useState } from 'react';

import { fetchMosProducts } from '@services/mosSwitchers';

import MosProductItem from './components/MosProductItem';

const ENABLED_PRODUCT_STATUS = 'Enabled';

/**
 * InPulse is the current product; AI is never listed (MOS product switcher visibility rule).
 */
const HIDDEN_PRODUCT_CODES = ['inpulse', 'ai'];

const isProductVisible = ({ code, status }) => {
  if (HIDDEN_PRODUCT_CODES.includes(code)) {
    return false;
  }

  return status === ENABLED_PRODUCT_STATUS;
};

/**
 * Drawer content listing the MOS products of the user, opened from the sidebar logo.
 */
const MosProductList = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    let isCancelled = false;

    fetchMosProducts()
      .then((fetchedProducts) => {
        if (isCancelled) {
          return;
        }

        setProducts(fetchedProducts.filter(isProductVisible));
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('[MOS] products fetch failed:', error);
      });

    return () => {
      isCancelled = true;
    };
  }, []);

  const handleProductClick = ({ url }) => {
    if (!url) {
      return;
    }

    window.location.assign(url);
  };

  return products.map((product) => (
    <MosProductItem
      key={product.code}
      product={product}
      onClick={() => handleProductClick(product)}
    />
  ));
};

export default MosProductList;
